import {
  Box,
  Divider,
  Flex,
  Image,
  Text,
  useColorMode,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { getCurrentColor, offsetTopStatus } from "../../constants";
import { Link } from "@chakra-ui/react";
import { CheckIcon } from "@chakra-ui/icons";
import { cautionStatus } from "../../utils/cautionStatus";

const ToolTipTotalPlus = ({
  children,
  ship_cost,
  status,
  price,
  membership_url,
  membership_img_lt,
  membership_img_dk,
  item_discount,
  ship_discount,
}) => {
  const [showToolTip, setShowToolTip] = useState(false);
  const { colorMode } = useColorMode();
  const elementRef = useRef(null);
  const [offsetTop, setOffsetTop] = useState(0);

  const controlScroll = () => {
    setShowToolTip(false);
    if (elementRef.current) {
      const rect = elementRef.current.getBoundingClientRect();
      setOffsetTop(rect.top);
    }
  };

  useEffect(() => {
    document.addEventListener("scroll", controlScroll);

    return () => {
      document.removeEventListener("scroll", controlScroll);
    };
  }, []);

  const itemCostDiscount = (+price - +price * item_discount).toFixed(2);
  const shipCostDiscount =
    +ship_discount === 1
      ? 0.0
      : (+ship_cost - +ship_cost * ship_discount).toFixed(2);
  const totalDiscount = (+itemCostDiscount + +shipCostDiscount).toFixed(2);

  return (
    <Box
      position={"relative"}
      onMouseOver={() => setShowToolTip(true)}
      onMouseLeave={() => setShowToolTip(false)}
      cursor={"pointer"}
      ref={elementRef}
    >
      <Text display={"flex"} alignItems={"center"} cursor={"help"} gap={"6px"}>
        {children}
      </Text>

      {showToolTip && (
        <Flex
          flexDirection={"column"}
          position={"absolute"}
          bottom={offsetTopStatus(offsetTop) ? "auto" : 6}
          top={offsetTopStatus(offsetTop) ? { base: 7, md: 6 } : "auto"}
          right={{ base: "-20px", md: "0px" }}
          zIndex={100}
          bg={getCurrentColor(colorMode, "whiteC.100", "grayC.1700")}
          w={{ base: "300px", md: "400px" }}
          borderRadius={"5px"}
          boxShadow={"0px 4px 15px 0px rgba(0, 0, 0, 0.15)"}
          cursor={"auto"}
        >
          <Box
            position={"absolute"}
            bottom={offsetTopStatus(offsetTop) ? "auto" : "-15px"}
            top={offsetTopStatus(offsetTop) ? "-20px" : "auto"}
            right={offsetTopStatus(offsetTop) ? "7px" : 0}
            zIndex={99}
            bg={"transparent"}
            w={"110px"}
            h={"20px"}
            cursor={"help"}
          ></Box>
          <Flex
            gap={"6px"}
            fontSize={"md"}
            color={getCurrentColor(colorMode, "blackC.200", "whiteC.200")}
            fontWeight={"600"}
            bg={getCurrentColor(colorMode, "grayC.1100", "blueC.1000")}
            px={3}
            pt={3}
            pb={"14px"}
            borderTopRadius={"5px"}
            border={"1px solid"}
            borderColor={getCurrentColor(colorMode, "grayC.1200", "grayC.3700")}
            borderBottom={"none"}
          >
            Total Cost Breakdown
          </Flex>
          <Flex
            flexDirection={"column"}
            bg={getCurrentColor(colorMode, "whiteC.100", "blueC.1100")}
            px={"18px"}
            py={3}
            color={getCurrentColor(colorMode, "grayC.200", "grayC.1600")}
            fontSize={"sm"}
            fontWeight={"600"}
            borderBottomRadius={"5px"}
            position={"relative"}
            border={"1px solid"}
            borderColor={getCurrentColor(colorMode, "grayC.1200", "grayC.3700")}
          >
            <Flex mb={4} variant="unstyled" w="100%" flexDirection={"column"}>
              <Flex w="100%" justifyContent={"flex-end"} gap={2}>
                <Text
                  textAlign="end"
                  fontWeight="medium"
                  w={{ base: "20", md: "28" }}
                >
                  Standard
                </Text>
                <Box bg="gray.700" w={"1px"} />
                <Flex justifyContent={"flex-end"} w={{ base: "20", md: "28" }}>
                  <Image
                    src={getCurrentColor(
                      colorMode,
                      membership_img_lt,
                      membership_img_dk,
                    )}
                    alt="Ammo Plus Logo"
                    width={"60px"}
                    height={"20px"}
                    objectFit={"scale-down"}
                    h="5"
                  />
                </Flex>
              </Flex>

              <Flex mt={3} w={"100%"} gap={2} justifyContent={"space-between"}>
                <Text flexGrow={1}>Item Cost:</Text>

                <Text
                  textAlign="end"
                  fontWeight="medium"
                  fontSize={{ base: "xs", md: "sm" }}
                  w={{ base: "20", md: "28" }}
                >
                  ${(+price).toFixed(2)}
                </Text>
                <Box bg="gray.700" w={"1px"} />
                <Flex
                  justifyContent={"flex-end"}
                  alignItems={"flex-end"}
                  gap={2}
                  w={{ base: "20", md: "28" }}
                >
                  <Text fontWeight="medium" fontSize={{ base: "xs", md: "sm" }}>
                    ${itemCostDiscount}
                  </Text>
                  <Text color="green.500" fontSize={{ base: "10px", md: "xs" }}>
                    -{item_discount * 100}%
                  </Text>
                </Flex>
              </Flex>

              <Flex w={"100%"} gap={2} justifyContent={"space-between"} mt={2}>
                <Text flexGrow={1}>Shipping:</Text>
                <Text
                  textAlign="right"
                  fontWeight="medium"
                  w={{ base: "20", md: "28" }}
                  fontSize={{ base: "xs", md: "sm" }}
                >
                  ${(+ship_cost).toFixed(2)}*
                </Text>
                <Box bg="gray.700" w={"1px"} />
                <Flex
                  justifyContent={"flex-end"}
                  alignItems={"flex-end"}
                  gap={2}
                  w={{ base: "20", md: "28" }}
                >
                  <Text fontWeight="medium" fontSize={{ base: "xs", md: "sm" }}>
                    ${shipCostDiscount}
                  </Text>
                  <Text color="green.500" fontSize={{ base: "10px", md: "xs" }}>
                    {+ship_discount === 1 ? "FREE" : `-${ship_discount * 100}%`}
                  </Text>
                </Flex>
              </Flex>

              <Divider borderColor="gray.700" my={2} />

              <Flex w={"100%"} gap={2} justifyContent={"space-between"} mt={2}>
                <Text flexGrow={1}>Total:</Text>
                <Text
                  textAlign="right"
                  fontWeight="medium"
                  fontSize={{ base: "xs", md: "sm" }}
                  w={{ base: "20", md: "28" }}
                >
                  ${(+price + +ship_cost).toFixed(2)}
                </Text>
                <Box bg="gray.700" w={"1px"} />
                <Text
                  textAlign="right"
                  fontWeight="medium"
                  color="green.400"
                  w={{ base: "20", md: "28" }}
                  fontSize={{ base: "xs", md: "sm" }}
                >
                  ${totalDiscount}
                </Text>
              </Flex>

              <Flex w={"100%"} gap={2} justifyContent={"space-between"} mt={2}>
                <Text flexGrow={1}>You Save:</Text>

                <Box bg="gray.700" w={"1px"} />
                <Text
                  textAlign="right"
                  fontWeight="medium"
                  color="green.400"
                  w={{ base: "20", md: "28" }}
                  fontSize={{ base: "xs", md: "sm" }}
                >
                  ${(+price + +ship_cost - totalDiscount).toFixed(2)}
                </Text>
              </Flex>

              <Box textAlign="right" mt={2}>
                <Link
                  href={membership_url}
                  fontSize="xs"
                  color="blueC.200"
                  target="_blank"
                  _hover={{ color: "blue.300", textDecoration: "underline" }}
                  style={{ color: "#2F80ED", fontSize: "12px" }}
                >
                  Ammo+ Membership Info
                </Link>
              </Box>

              <Divider borderColor="gray.700" my={2} />

              <Flex
                w={"100%"}
                mb={2}
                gap={2}
                justifyContent={"flex-start"}
                alignItems={"flex-start"}
                mt={2}
              >
                <Box>
                  <CheckIcon color={"greenC.300"} />
                </Box>
                {cautionStatus(status)?.text}
              </Flex>
              <Text textAlign={"start"} fontSize={{ base: "10px", md: "xs" }}>
                *Shipping cost may vary on vendor's site.
              </Text>
            </Flex>
          </Flex>
        </Flex>
      )}
    </Box>
  );
};

export default ToolTipTotalPlus;
